import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/basicInfo';
const basicInformation: Array<RouteConfig> = [
    {
        path: 'basic-info',
        name: 'basicInfo',
        redirect: { name: 'principal' },
        meta: {
            menuMatch: 'basicInfo',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'principal',
                name: 'principal',
                component: () => import(`@/${BASE_PATH}/Principal.vue`),
                meta: {
                    index: '1-1',
                },
            },
            {
                path: 'organization',
                name: 'organization',
                component: () => import(`@/${BASE_PATH}/Organization.vue`),
                meta: {
                    index: '1-2',
                },
            },
            {
                path: 'personnel',
                name: 'personnel',
                component: () => import(`@/${BASE_PATH}/personnel/Personnel.vue`),
                meta: {
                    index: '1-3',
                },
            },
            {
                path: 'permissions',
                name: 'permissions',
                component: () => import(`@/${BASE_PATH}/permissions/Permissions.vue`),
                meta: {
                    index: '1-4',
                },
            },
            {
                path: 'permissions-detail',
                name: 'permissionsDetail',
                component: () => import(`@/${BASE_PATH}/permissions/PermissionsDetail.vue`),
                meta: {
                    index: '1-4',
                },
            },
            {
                path: 'field',
                name: 'field',
                component: () => import(`@/${BASE_PATH}/field/Field.vue`),
                meta: {
                    index: '1-5',
                },
            },
            {
                path: 'warehouse',
                name: 'warehouse',
                component: () => import(`@/${BASE_PATH}/warehouse/Warehouse.vue`),
                meta: {
                    index: '1-6',
                },
            },
        ],
    },
];
export default basicInformation;